export default __webpack_public_path__ + "static/media/domain-active.357472ff.svg";